import * as yup from 'yup';
import React from 'react';
import { useFormik } from 'formik';
import CustomFormLabel from 'src/components/forms/theme-elements/CustomFormLabel';
import CustomTextField from 'src/components/forms/theme-elements/CustomTextField';
import { useDispatch, useSelector } from 'react-redux';
import { bankAdd, bankEdit, bankSelector } from 'src/store/apps/slices/BankSlice';
import {
  Grid,
  Box,
  FormControlLabel
} from '@mui/material';
import CustomSwitch from '../../../components/forms/theme-elements/CustomSwitch';
import { isEmpty } from 'lodash';
import { ACTIVE_LK, INACTIVE_LK } from 'src/lib/constants';

const { default: FormDialog } = require('src/components/material-ui/dialog/FormDialog');

const getValidationSchema = () => {
  return yup.object({
    bank_name: yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Bank Name is Required.'),
  });
};

const initialState = {
  bank_name: '',
  is_active: true,
};

const Bank = ({ open, handleClose, bank }) => {
  const { submitLoading, formError } = useSelector(bankSelector);
  const validationSchema = getValidationSchema();
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: initialState,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const data = {
        bank_name: values.bank_name,
        is_active: values.is_active ? true : false,
      };

      if (bank) {
        dispatch(bankEdit({id: bank?.id, data: data}))
        
      } else {
        dispatch(bankAdd(data));
      }
    },
  });

  React.useEffect(() => {
    if (!bank) return;
    formik.setValues({ ...bank });

  }, [bank]);

  React.useEffect(() => {
    !open && formik.resetForm();
  }, [open]);

  React.useEffect(() => {
        if (!isEmpty(formError)) {
            formik.setErrors(formError);
        }else {
            handleClose();
        }
    }, [formError]);

  const handleSubmit = (e) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  return (
    <FormDialog
      open={open}
      handleClose={() => {
        handleClose();
      }}
      title="Bank"
      handleSubmit={handleSubmit}
      submitLoading={submitLoading}
    >
      <Box>
        <CustomFormLabel required>Bank Name</CustomFormLabel>
        <CustomTextField
          fullWidth
          id="bank_name"
          name="bank_name"
          value={formik?.values?.bank_name}
          onChange={formik.handleChange}
          error={formik.touched.bank_name && Boolean(formik.errors.bank_name)}
          helperText={formik.touched.bank_name && formik.errors.bank_name}
        />
      </Box>
      
      <Box>
        <CustomFormLabel>Activation</CustomFormLabel>
          <Grid container spacing={0}>
            <Grid item xs={12} sm={6} lg={3}>
              <FormControlLabel
                control={
                  <CustomSwitch
                    checked={formik?.values?.is_active === true}
                    onChange={(e) => formik.setFieldValue('is_active', e.target.checked ? true : false)}
                    value={true}
                    name="is_active"
                    id="is_active"
                  />
                }
                label={formik?.values?.is_active === true ? ACTIVE_LK : INACTIVE_LK}
              />

            </Grid>
            
          </Grid>
      </Box>
    </FormDialog>
  );
};

export default Bank;
